export const translateKey = (
  key: string,
  keyType: 'camelot' | 'classic' | 'metadata',
): string => {
  const map: Record<string, string> = {
    C: '8B',
    G: '9B',
    D: '10B',
    A: '11B',
    E: '12B',
    B: '1B',
    'F#': '2B',
    'C#': '3B',
    F: '7B',
    Bb: '6B',
    Eb: '5B',
    Ab: '4B',
    Db: '3B',
    Gb: '2B',
    Cb: '1B',
    Am: '8A',
    Em: '9A',
    Bm: '10A',
    'F#m': '11A',
    'C#m': '12A',
    'G#m': '1A',
    'D#m': '2A',
    'A#m': '3A',
    Dm: '7A',
    Gm: '6A',
    Cm: '5A',
    Fm: '4A',
    Bbm: '3A',
    Ebm: '2A',
    Abm: '1A',
  };

  const reverseMap: Record<string, string> = Object.fromEntries(
    Object.entries(map).map(([k, v]) => [v, k]),
  );

  return keyType == 'camelot'
    ? map[key] || key
    : keyType == 'classic'
      ? reverseMap[key] || key
      : key;
};
